var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3407_24729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75 33.75H18.75V37.5H33.75V33.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 24.375H18.75V28.125H41.25V24.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 43.125H18.75V46.875H28.125V43.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875 9.375H42.25C41.6977 9.375 41.25 8.92728 41.25 8.375V7.5C41.25 6.50544 40.8549 5.55161 40.1516 4.84835C39.4484 4.14509 38.4946 3.75 37.5 3.75H22.5C21.5054 3.75 20.5516 4.14509 19.8484 4.84835C19.1451 5.55161 18.75 6.50544 18.75 7.5V8.375C18.75 8.92728 18.3023 9.375 17.75 9.375H13.125C12.1304 9.375 11.1766 9.77009 10.4733 10.4733C9.77009 11.1766 9.375 12.1304 9.375 13.125V52.5C9.375 53.4946 9.77009 54.4484 10.4733 55.1516C11.1766 55.8549 12.1304 56.25 13.125 56.25H46.875C47.8696 56.25 48.8234 55.8549 49.5266 55.1516C50.2299 54.4484 50.625 53.4946 50.625 52.5V13.125C50.625 12.1304 50.2299 11.1766 49.5266 10.4733C48.8234 9.77009 47.8696 9.375 46.875 9.375ZM22.5 8.5C22.5 7.94772 22.9477 7.5 23.5 7.5H36.5C37.0523 7.5 37.5 7.94772 37.5 8.5V14C37.5 14.5523 37.0523 15 36.5 15H23.5C22.9477 15 22.5 14.5523 22.5 14V8.5ZM46.875 51.5C46.875 52.0523 46.4273 52.5 45.875 52.5H14.125C13.5727 52.5 13.125 52.0523 13.125 51.5V14.125C13.125 13.5727 13.5727 13.125 14.125 13.125H17.75C18.3023 13.125 18.75 13.5727 18.75 14.125V17.75C18.75 18.3023 19.1977 18.75 19.75 18.75H40.25C40.8023 18.75 41.25 18.3023 41.25 17.75V14.125C41.25 13.5727 41.6977 13.125 42.25 13.125H45.875C46.4273 13.125 46.875 13.5727 46.875 14.125V51.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3407_24729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon03);
export default __webpack_public_path__ + "static/media/report_icon_03.7fa022fc0f4ee0c9121f197bd806b048.svg";
export { ForwardRef as ReactComponent };